import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=5e069bc2&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=5e069bc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e069bc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e069bc2')) {
      api.createRecord('5e069bc2', component.options)
    } else {
      api.reload('5e069bc2', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=5e069bc2&scoped=true&", function () {
      api.rerender('5e069bc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8Q4gxtK7BSnHU/JS/comp/DocBox.vue"
export default component.exports